import React, { useState, useEffect } from 'react';
import { getHostelComplaints, updateComplaintStatus } from '../../../services/hostelService';
import toast from 'react-hot-toast';

const STATUS_COLORS = {
  open: 'bg-red-100 text-red-700',
  assigned: 'bg-yellow-100 text-yellow-700',
  'in-progress': 'bg-blue-100 text-blue-700',
  resolved: 'bg-green-100 text-green-700',
  closed: 'bg-gray-100 text-gray-600',
};

const STATUS_OPTIONS = ['open', 'assigned', 'in-progress', 'resolved', 'closed'];

const HostelComplaints = ({ coachingId }) => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => { loadComplaints(); }, [coachingId]);

  const loadComplaints = async () => {
    setLoading(true);
    const data = await getHostelComplaints(coachingId);
    setComplaints(data);
    setLoading(false);
  };

  const handleStatusChange = async (id, newStatus) => {
    const notes = newStatus === 'resolved' ? prompt('Resolution notes (optional):') : '';
    await updateComplaintStatus(id, newStatus, notes || '');
    toast.success(`Status updated to ${newStatus}`);
    loadComplaints();
  };

  const filtered = filter === 'all' ? complaints : complaints.filter(c => c.status === filter);

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h2 className="text-lg font-semibold text-gray-800 dark:text-white">Complaints ({filtered.length})</h2>
        <div className="flex gap-2 flex-wrap">
          {['all', ...STATUS_OPTIONS].map(s => (
            <button key={s} onClick={() => setFilter(s)}
              className={`px-3 py-1 rounded-full text-xs font-medium ${filter === s ? 'bg-blue-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'}`}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        {filtered.map(c => (
          <div key={c.id} className="bg-white dark:bg-gray-800 border rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${STATUS_COLORS[c.status] || STATUS_COLORS.open}`}>{c.status}</span>
                  <span className="text-xs text-gray-400">{c.category}</span>
                </div>
                <p className="text-sm text-gray-800 dark:text-white">{c.description}</p>
                <p className="text-xs text-gray-400 mt-2">By: {c.studentName || c.studentId}</p>
                {c.resolutionNotes && <p className="text-xs text-green-600 mt-1">Resolution: {c.resolutionNotes}</p>}
              </div>
              <select value={c.status} onChange={e => handleStatusChange(c.id, e.target.value)}
                className="border rounded-lg px-2 py-1 text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="text-gray-400 text-sm text-center py-8">No complaints found.</p>}
      </div>
    </div>
  );
};

export default HostelComplaints;
